// extracted by mini-css-extract-plugin
export var center = "topic-selector-module--center--5fed1";
export var headline = "topic-selector-module--headline--19fc8";
export var left = "topic-selector-module--left--4988f";
export var links = "topic-selector-module--links--99066";
export var right = "topic-selector-module--right--439ab";
export var topicSelector = "topic-selector-module--topic-selector--cdf4e";